import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/categories";
import { heroBackground } from "@/mocks/images";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroBackground}
          alt="USFans Spreadsheet resource hub"
          title="USFans Spreadsheet resources and guides"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/70 to-background-50"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-4xl flex-col items-center px-4 py-16 text-center md:px-6 md:py-24">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-background-50/80 px-4 py-1.5 text-xs font-medium text-primary-700">
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-shield-check-line text-sm"></i>
          </span>
          {t("hero.badge")}
        </span>

        <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
          {t("hero.title")}
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
          {t("hero.subtitle")}
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className="ri-grid-line text-base"></i>
            </span>
            {t("cta.usfansSpreadsheet")}
          </a>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 sm:w-auto"
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className="ri-shopping-bag-3-line text-base"></i>
            </span>
            {t("cta.buyItNow")}
          </a>
        </div>

        <p className="mt-6 text-xs text-foreground-600">{t("hero.trust")}</p>
      </div>
    </section>
  );
}